(() => {
  const bar = document.querySelector('[data-bobbo-sticky-product]');
  const form = document.getElementById('ReferenceProductForm');
  if (!bar || !form || form.dataset.referenceOnly === 'true') return;
  const quantity = form.elements.quantity, input = bar.querySelector('[data-sticky-quantity]');
  const primary = form.querySelector('[type="submit"]'), add = bar.querySelector('[data-sticky-add]');
  const product = form.closest('[data-reference-product]');
  const variants = JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
  const initialImage = bar.querySelector('img')?.src;
  let queued = false;
  function sync() {
    input.value = quantity.value;
    for (const key of ['min', 'max', 'step']) {
      if (quantity.hasAttribute(key)) input.setAttribute(key, quantity.getAttribute(key));
      else input.removeAttribute(key);
    }
    bar.querySelector('[data-sticky-step="-1"]').disabled = Number(input.value) <= Number(input.min || 1);
    bar.querySelector('[data-sticky-step="1"]').disabled = !!input.max && Number(input.value) >= Number(input.max);
    const busy = !!form.dataset.busy;
    add.disabled = primary.disabled || busy;
    add.textContent = busy ? 'Adding…' : primary.disabled ? 'Sold out' : 'Add to cart';
    input.disabled = busy;
    bar.querySelector('[data-sticky-price]').textContent = product.querySelector('[data-reference-price]').textContent;
    bar.querySelector('[data-sticky-status]').textContent = form.querySelector('[role="status"]')?.textContent || '';
    const id = new FormData(form).get('id');
    const image = bar.querySelector('img'), variant = variants.find(v => String(v.id) === String(id));
    if (image && (variant?.image || initialImage)) { image.removeAttribute('srcset'); image.src = variant?.image || initialImage; }
  }
  function update() {
    queued = false;
    const obscured = document.body.classList.contains('reference-scroll-locked') || !!document.querySelector('dialog[open],#menuDrawer.is-open');
    const visible = primary.getBoundingClientRect().bottom <= 0 && !obscured;
    bar.dataset.visible = String(visible);
    bar.setAttribute('aria-hidden', String(!visible));
    bar.inert = !visible;
    if (document.body.classList.contains('bobbo-sticky-product-on') !== visible) document.body.classList.toggle('bobbo-sticky-product-on', visible);
    if (document.querySelector('#ReferenceCartDrawer[open]')) bar.querySelector('[data-sticky-status]').textContent = '';
    document.documentElement.style.setProperty('--bobbo-buybar-height', bar.offsetHeight + 'px');
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function setQuantity() {
    const min = Number(quantity.min) || 1, max = Number(quantity.max) || Infinity;
    input.value = Math.max(min, Math.min(max, Math.floor(Number(input.value) || min)));
    quantity.value = input.value;
    quantity.dispatchEvent(new Event('change', {bubbles:true}));
    sync();
  }
  bar.addEventListener('click', event => {
    const step = event.target.closest('[data-sticky-step]');
    if (step) { Number(step.dataset.stickyStep) > 0 ? input.stepUp() : input.stepDown(); setQuantity(); }
    if (event.target.closest('[data-sticky-add]') && !add.disabled) {
      setQuantity();
      form.requestSubmit(primary);
    }
  });
  input.addEventListener('change', setQuantity);
  form.addEventListener('input', sync);
  form.addEventListener('change', sync);
  form.addEventListener('click', () => queueMicrotask(sync));
  product.addEventListener('change', () => queueMicrotask(sync));
  new MutationObserver(sync).observe(form, {subtree:true, attributes:true, attributeFilter:['disabled','data-busy'], childList:true, characterData:true});
  new MutationObserver(schedule).observe(document.body, {attributes:true, attributeFilter:['class']});
  document.querySelectorAll('dialog').forEach(dialog => new MutationObserver(schedule).observe(dialog, {attributes:true, attributeFilter:['open']}));
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule);
  sync(); update();
})();
